export default {
    computed: {
      promotions() {
        return this.$store.getters.getPromotion;
      },
      activePromotion() {
        if (this.promotions && this.promotions.active) {
          return this.promotions.active;
        }
        return false; // Fallback if no promotion data
      },
    },
  };